import { render, staticRenderFns } from "./SubHistory.vue?vue&type=template&id=0ecba6dc&"
import script from "./SubHistory.vue?vue&type=script&lang=js&"
export * from "./SubHistory.vue?vue&type=script&lang=js&"
import style0 from "./SubHistory.vue?vue&type=style&index=0&id=0ecba6dc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports